import { useEffect } from 'react';

const useMasthead = () => {
  useEffect(() => {
    var VideoButton = (function () {
      function getdef(val, def) {
        return val == null ? def : val;
      }

      function videoButton(options) {
        options = options || {};

        var sliderClass = getdef(options.sliderClass, 'c-masthead__slider__item');
        var videoButtonClass = getdef(options.videoButtonClass, 'c-button--video');
        var skipVideoButtonClass = getdef(
          options.skipVideoButtonClass,
          'c-masthead__slider__item__content__footer__skip'
        );
        var stopVideoButtonClass = getdef(
          options.skipVideoButtonClass,
          'c-masthead__slider__item__content__footer__stop'
        );
        var muteVideobuttonClass = getdef(
          options.muteVideobuttonClass,
          'c-masthead__slider__item__content__footer__mute'
        );
        var playFullVideoButtonClass = getdef(
          options.playFullVideoButtonClass,
          'c-masthead__slider__item__content__theme__cta__video'
        );
        var attributeLabelNamelPlay = getdef(options.attributeLabelNamelPlay, 'sr-label-play');
        var attributeLabelNamelPause = getdef(options.attributeLabelNamelPause, 'sr-label-pause');
        var attributeIconNamelPlay = getdef(options.attributeIconNamelPlay, 'sr-icon-play');
        var attributeIconNamelPause = getdef(options.attributeIconNamelPause, 'sr-icon-pause');
        var mastheadSliderObject = getdef(options.mastheadSliderObject, null);
        var ctaButtonClass = getdef(options.ctaButtonClass, 'c-button c-button--cta');

        function renderSliderVideoButton() {
          var sliderItems = document.querySelectorAll('.' + sliderClass);
          sliderItems.forEach(function (sliderItem) {
            if (sliderItem === null) return;

            var videoEl = sliderItem.querySelector('video');
            var btnElm = sliderItem.querySelector('.' + videoButtonClass);
            var btnSkipVideo = sliderItem.querySelector('.' + skipVideoButtonClass);
            var btnStopVideo = sliderItem.querySelector('.' + stopVideoButtonClass);
            var btnMuteVideo = sliderItem.querySelectorAll('.' + muteVideobuttonClass);
            var btnPlayFullVideo = sliderItem.querySelector('.' + playFullVideoButtonClass);

            renderVideoButton(videoEl, btnElm);
            renderSkipVideoButton(videoEl, btnSkipVideo);
            renderStopVideoButton(videoEl, btnStopVideo);
            renderMuteVideoButton(videoEl, btnMuteVideo);
            renderPlayFullVideoButton(videoEl, btnPlayFullVideo);
            attachIntersectionObserverVideoStopPlay(videoEl);
            attachEventListener(videoEl);
          });
        }

        function videoTracking(type, fileName) {
          if (window._satellite === undefined || window._satellite === null) return;
          window._satellite.track(type, { VideoName: fileName });
        }

        function showoVideoCaptureVTT(video) {
          for (let i = 0; i < video.textTracks.length; i++) {
            if (video.currentSrc.includes(video.textTracks[i].label)) {
              video.textTracks[i].mode = 'showing';
            } else {
              video.textTracks[i].mode = 'hidden';
            }
          }
        }

        function attachEventListener(videoEl) {
          if (videoEl === null) return;

          videoEl.addEventListener('play', function () {
            showoVideoCaptureVTT(this);
            videoEl.classList.add('is-play');
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'hidden';
            }
            try {
              mastheadSliderObject.pause();
            } catch (e) {
              if (!(e instanceof TypeError)) {
                console.error(e);
              }
            }

            videoTracking('video-play', this.currentSrc);
          });
          /* play video if autoplay
                    if (videoEl.classList.contains('is-autoplay')) {
                        console.log('video is played')
                        videoEl.play();
                    } else {
                        console.log('ijnininiuniun');
                        videoEl.classList.remove('is-play');
                        videoEl.classList.add('is-stop');
                    }*/

          videoEl.addEventListener('ended', function () {
            videoEl.classList.add('is-stop');
            videoEl.classList.remove('is-play');
            videoEl.classList.remove('is-autoplay');
            // videoEl.pause();
            // videoEl.currentTime = videoEl.duration;
            try {
              mastheadSliderObject.resume();
            } catch (e) {
              if (!(e instanceof TypeError)) {
                console.error(e);
              }
            }
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'visible';
            }

            if (videoEl.currentTime > videoEl.duration / 2) {
              videoTracking('video-end-duration-above-50', this.currentSrc);
            }

            videoTracking('video-end', this.currentSrc);
          });

          videoEl.addEventListener('volumechange', function () {
            videoEl.muted ? videoEl.classList.add('is-mute') : videoEl.classList.remove('is-mute');
          });

          videoEl.addEventListener('error', function () {
            videoEl.classList.add('is-stop');
            videoEl.classList.remove('is-play');
            videoEl.classList.remove('is-autoplay');
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'visible';
            }
            videoTracking('video-error', this.currentSrc);
          });
        }

        function attachIntersectionObserverVideoStopPlay(videoEl) {
          if (videoEl === null) return;
          var options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.05,
          };
          var callback = function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) {
                //videoEl.currentTime = videoEl.duration;
              }
            });
          };

          var observer = new IntersectionObserver(callback, options);
          observer.observe(videoEl);
        }

        function renderSkipVideoButton(videoEl, btnElm) {
          if (videoEl === null || btnElm === null) return;

          function skipVideo() {
            videoEl.classList.add('is-stop');
            videoEl.classList.remove('is-play');
            videoEl.classList.remove('is-autoplay');
            videoEl.pause();
            videoEl.currentTime = videoEl.duration;
            try {
              mastheadSliderObject.resume();
            } catch (e) {
              if (!(e instanceof TypeError)) {
                console.error(e);
              }
            }
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'visible';
            }
            videoTracking('video-skip', videoEl.currentSrc);
          }

          btnElm.addEventListener('click', skipVideo);
          btnElm.addEventListener('keypress', function (e) {
            e.keyCode === 13 && skipVideo();
          });
        }

        function renderStopVideoButton(videoEl, btnElm) {
          if (videoEl === null || btnElm === null) return;

          function stopVideo() {
            videoEl.classList.add('is-stop');
            videoEl.classList.remove('is-play');
            videoEl.classList.remove('is-autoplay');
            videoEl.pause();
            videoEl.currentTime = videoEl.duration;
            try {
              mastheadSliderObject.resume();
            } catch (e) {
              if (!(e instanceof TypeError)) {
                console.error(e);
              }
            }
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'visible';
            }
            videoTracking('video-stop', videoEl.currentSrc);
          }
          btnElm.addEventListener('click', stopVideo);
          btnElm.addEventListener('keypress', function (e) {
            e.keyCode === 13 && stopVideo();
          });
        }

        function renderMuteVideoButton(videoEl, btnElm) {
          if (videoEl === null || btnElm === null) return;

          function muteVideo() {
            videoEl.muted = !videoEl.muted;
            videoTracking(
              videoEl.muted ? 'video-click-muted' : 'video-click-unmuted',
              videoEl.currentSrc
            );
          }

          btnElm.forEach(function (element) {
            element.addEventListener('click', muteVideo);
            element.addEventListener('keypress', function (e) {
              e.keyCode === 13 && muteVideo();
            });
          });
        }

        function renderPlayFullVideoButton(videoEl, btnElm) {
          if (videoEl === null || btnElm === null) return;

          function PlayFullVideo() {
            var wrapper = document.querySelector('.c-masthead__indicator-wrapper');
            if (wrapper !== null) {
              wrapper.style.visibility = 'hidden';
            }
            videoEl.src = this.dataset.videourl;
            videoEl.crossOrigin = 'anonymous';
            try {
              mastheadSliderObject.pause();
            } catch (e) {
              if (!(e instanceof TypeError)) {
                console.error(e);
              }
            }
            var playPromise = videoEl.play();

            // In browsers that don’t yet support this functionality,
            // playPromise won’t be defined.
            if (playPromise !== undefined) {
              playPromise
                .then(function () {
                  // Automatic playback started!
                })
                .catch(function (error) {
                  // Automatic playback failed.
                  // Show a UI element to let the user manually start playback.
                });
            }
            videoEl.muted = false;
            videoEl.classList.remove('is-stop');
            videoEl.classList.remove('is-autoplay');
            videoEl.classList.add('is-play');
            videoTracking('video-click-play-full-video', videoEl.currentSrc);
          }

          btnElm.addEventListener('click', PlayFullVideo);
          btnElm.addEventListener('keypress', function (e) {
            e.keyCode === 13 && PlayFullVideo.bind(this)();
          });
        }

        function renderVideoButton(videoEl, btnElm) {
          if (videoEl === null || btnElm === null) return;

          var labelPlay = getdef(btnElm.getAttribute(attributeLabelNamelPlay), 'Play video');
          var labelPause = getdef(btnElm.getAttribute(attributeLabelNamelPause), 'Pause video');
          var iconPlay = getdef(btnElm.getAttribute(attributeIconNamelPlay), 'far fa-play-circle');
          var iconPause = getdef(
            btnElm.getAttribute(attributeIconNamelPause),
            'far fa-pause-circle'
          );

          var videoButton = document.createElement('div');
          var videoIconic = document.createElement('i');
          var videoLabel = document.createElement('div');

          videoButton.className = videoButtonClass + '__cta';
          videoIconic.className = iconPause;
          videoButton.appendChild(videoIconic);

          videoLabel.className = videoButtonClass + '__label';
          videoLabel.innerHTML = labelPause;

          btnElm.appendChild(videoButton);
          btnElm.appendChild(videoLabel);
          btnElm.setAttribute('tabindex', 0);
          btnElm.setAttribute('aria-label', labelPause);

          var videoEventListener = function () {
            if (videoEl.paused) {
              videoEl.play();
              videoLabel.innerHTML = labelPause;
              videoIconic.className = iconPause;
              btnElm.setAttribute('aria-label', labelPause);
            } else {
              videoEl.pause();
              videoLabel.innerHTML = labelPlay;
              videoIconic.className = iconPlay;
              btnElm.setAttribute('aria-label', labelPlay);
            }
          };

          btnElm.addEventListener('click', videoEventListener);
          btnElm.addEventListener('keypress', function (e) {
            if (e.keyCode === 13) {
              videoEventListener();
            }
          });
        }

        return {
          renderSliderVideoButton: renderSliderVideoButton,
          renderVideoButton: renderVideoButton,
        };
      }

      return videoButton;
    })();

    var MastheadSlider = (function () {
      function getdef(val, def) {
        return val == null || val === '' ? def : val;
      }

      function len(arr) {
        return (arr || []).length;
      }

      function getShiftValue(trProp, val, unit) {
        var result = 'translate(';
        if (trProp === 'left') {
          result += val + unit + ', 0';
        } else {
          result += '0, ' + val + unit;
        }
        return result + ')';
      }

      function startSlides(containerElem, children, unit, startVal, visVal, trProp) {
        var style = void 0,
          slides = [];

        if (!children) {
          children = containerElem.children;
        }

        var i = len(children);

        while (--i >= 0) {
          slides[i] = children[i];
          style = slides[i].style;
          style.position = 'absolute';
          style.top = style.left = style.zIndex = 0;
          if (i > 0) {
            style.transform = getShiftValue(trProp, startVal, unit);
          }
        }
        slides = children;

        style.zIndex = 1;

        startIntroOnSlide(slides[0]);

        return slides;
      }

      function startIntroOnSlide(slide) {
        try {
          var videoEl = slide.querySelector('video');
          if (videoEl.classList.contains('is-autoplay') && window.innerWidth > 767) {
            videoEl.play();
          } else {
            videoEl.classList.remove('is-play');
            videoEl.classList.remove('is-autoplay');
            videoEl.classList.add('is-stop');
          }
        } catch (err) {}
      }

      function MastheadSlider(options) {
        options = options || {};
        var actualIndex = void 0,
          interval = void 0,
          animationInterval = void 0,
          intervalStartTime = void 0,
          slides = void 0,
          remainingTime = void 0;
        var mastHeadElem = document.querySelector('.c-masthead'); // getdef(options.id , document.querySelector('.c-masthead'))
        var containerElem = getdef(
          options.container,
          document.querySelector('*[data-masthead-slider]')
        );
        var arrowDownMoreElems = getdef(
          options.arrowDownMoreElem,
          document.querySelectorAll('.c-masthead__slider__item__content__footer__moreDown')
        );
        var trProp = getdef(options.prop, 'left');
        var trTime = getdef(options.duration, 0.5);
        var delay = getdef(options.delay, 7) * 1000;
        var unit = getdef(options.unit, '%');
        var startVal = getdef(options.init, -100);
        var visVal = getdef(options.show, 0);
        var endVal = getdef(options.end, 100);
        var paused = options.paused;
        var onChange = getdef(options.onChange, 0);
        var onChangeEnd = getdef(options.onChangeEnd, 0);
        var changeTimeout = null;
        var now = Date.now;

        for (var i = 0; i < arrowDownMoreElems.length; i++) {
          renderArrowDownMoreElem(arrowDownMoreElems[i]);
        }

        var barWidth = 0;
        const animateActiveBar = () => {
          var progressBar = document.querySelector(
            '.c-masthead__indicator__slider-bar.is-active > div'
          );
          barWidth++;
          progressBar.style.width = `${barWidth}%`;
        };

        function scrollToFirstElement() {
          var firstElement = document.querySelector('#content > div');

          if (!firstElement) {
            return;
          }

          //Have to hardcode c-top-navigation height during react migration, it's not accessible because it's in shadow root
          // window.scrollTo({
          //     behavior: 'smooth',
          //     top: firstElement.getBoundingClientRect().top - document.body.getBoundingClientRect().top - document.querySelector('.c-top-navigation').clientHeight,
          // })

          var topToScroll =
            firstElement.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            80;

          window.scrollTo({
            behavior: 'smooth',
            top: topToScroll,
          });
        }

        function renderArrowDownMoreElem(el) {
          if (el === null || el === undefined) return;

          el.addEventListener('click', function (event) {
            event.preventDefault();
            scrollToFirstElement();
          });

          el.addEventListener('keyup', function (event) {
            event.preventDefault();
            if (event.keyCode === 13) {
              scrollToFirstElement();
            }
          });
        }

        function reset() {
          if (containerElem && len(containerElem.children) > 0) {
            var style = containerElem.style;
            style.position = 'relative';
            style.overflow = 'hidden';
            style.display = 'block';

            slides = startSlides(containerElem, options.children, unit, startVal, visVal, trProp);
            actualIndex = 0;
            remainingTime = delay;
          }
        }

        function setAutoPlayLoop() {
          clearInterval(interval);
          interval = setInterval(() => {
            if (barWidth === 100) {
              barWidth = 0;
              change(nextIndex());
              clearInterval(interval);
              setAutoPlayLoop();
            } else {
              animateActiveBar();
            }
          }, delay / 100);
        }

        /*function updateLoadBar(time) {
                    clearInterval(animationInterval);
                    animationInterval = setInterval(() => {
                        if (barWidth === 100) {
                            barWidth = 0;
                            change(nextIndex());
                            clearInterval(animationInterval);
                            setAutoPlayLoop();
                        } else {
                            animateActiveBar();
                        }                
                    }, (time / 100));
                }*/

        function resume() {
          if (isAutoPlay()) {
            //intervalStartTime = now();
            setAutoPlayLoop();
          }
        }

        function isAutoPlay() {
          return !paused && len(slides) > 1;
        }

        function pause() {
          if (isAutoPlay()) {
            clearInterval(interval);
            //remainingTime = delay - (now() - intervalStartTime);
          }
        }

        function reverse() {
          var newEndVal = startVal;
          startVal = endVal;
          endVal = newEndVal;
          actualIndex = Math.abs(actualIndex - (len(slides) - 1));
          slides = slides.reverse();
        }

        function setInvertedOnIndicator(index) {
          //invert indicator if slide is inverted
          if (slides[index].classList.contains('is-inverted-indicator-flag')) {
            indicator.classList.add('is-inverted-indicator');
          } else {
            indicator.classList.remove('is-inverted-indicator');
          }
        }

        function change(newIndex) {
          // reset progressbar width
          barWidth = 100;
          animateActiveBar();
          barWidth = 0;

          if (slides === undefined) return;

          //if (changeTimeout) {
          //    clearInterval(changeTimeout);
          //}

          var count = len(slides);
          while (--count >= 0) {
            slides[count].style.transtion = 'none';
            if (count !== newIndex && count !== actualIndex) {
              slides[count].style.zIndex = 1;
            }
          }

          slides[newIndex].style.transform = getShiftValue(trProp, -endVal, unit);
          slides[actualIndex].style.transition = slides[newIndex].style.transition =
            'all ' + trTime + 's ease-in';

          slides[newIndex].style.zIndex = 3;
          slides[actualIndex].style.zIndex = 2;

          // visibility
          //slides[newIndex].style.visibility = 'visible';
          //slides[actualIndex].style.visibility = 'hidden';

          slides[actualIndex].style.transform = getShiftValue(trProp, endVal, unit);
          slides[newIndex].style.transform = getShiftValue(trProp, visVal, unit);

          let ai = actualIndex;
          changeTimeout = setTimeout(function () {
            slides[ai].style.transition = 'none';
            slides[ai].style.transform = getShiftValue(trProp, -endVal, unit);
          }, trTime * 1000);

          actualIndex = newIndex;
          indicatorSetActive(actualIndex);

          setInvertedOnIndicator(newIndex);

          if (onChange) {
            onChange(prevIndex(), actualIndex);
          }

          startIntroOnSlide(slides[actualIndex]);
        }

        function next() {
          change(nextIndex());
          resume();
        }

        function prev() {
          change(prevIndex());
          resume();
        }

        function nextIndex() {
          var newIndex = actualIndex + 1;
          return newIndex >= len(slides) ? 0 : newIndex;
        }

        function prevIndex() {
          var newIndex = actualIndex - 1;
          return newIndex < 0 ? len(slides) - 1 : newIndex;
        }

        function dispose() {
          clearInterval(interval);
          document.removeEventListener('visibilitychange', visibilityChange);

          slides =
            containerElem =
            interval =
            trProp =
            trTime =
            delay =
            startVal =
            endVal =
            paused =
            actualIndex =
            remainingTime =
            onChange =
            onChangeEnd =
              null;
        }

        function currentIndex() {
          return actualIndex;
        }

        function visibilityChange() {
          //It's commented during migration to react. onBlur is not present, doesn't looks like the function is excetued
          // if (onblur()) {
          //     pause();
          // } else {
          //     resume();
          // }
        }

        // The visibilitychange event is fired at the document when the content of its tab have become visible or have been hidden.
        // document.addEventListener('visibilitychange', visibilityChange);
        reset();

        if (len(slides) > 1) {
          resume();
        }

        // indicator

        var sliderContainer = document.querySelector('.c-masthead__slider');
        var titleElements = document.querySelectorAll('.c-masthead__indicator__title__placeholder');
        var indicator = document.createElement('div');
        var faDot = 'fa-circle';
        var faPlay = 'fa-play';
        var faPause = 'fa-pause';
        var prefix = 'c-masthead__indicator__';
        var segmentWrapperClass = prefix + 'segment-wrapper';
        var multipleSegmentWrapperClass = prefix + 'm-segment-wrapper';
        var indicatorTitle = prefix + 'title';
        var indicatorBar = prefix + 'slider-bar';
        var indicatorPause = prefix + 'action fas ' + faPause;
        var indicatorActive = 'is-active';
        var isUserAction = false;

        indicator.className = 'c-masthead__indicator';
        setInvertedOnIndicator(actualIndex);

        // Creating the multiple segment wrapper for more control with the css
        var mSegmentWrapper = document.createElement('div');
        mSegmentWrapper.className = multipleSegmentWrapperClass;

        for (var i = 0; i < sliderContainer.children.length; i++) {
          var segmentWrapper = document.createElement('div');
          segmentWrapper.className = segmentWrapperClass;

          var titleElem = document.createElement('div');
          titleElem.className = indicatorTitle;

          // make the titles visible so we can grab the title text
          // then we make set it back as inherit
          titleElements[i].style.visibility = 'visible';
          var title = titleElements[i].innerText;
          titleElements[i].style.visibility = 'inherit';
          // titleElem.innerHTML = title;
          titleElem.textContent = title;

          var progElem = document.createElement('div');
          progElem.className = indicatorBar;
          progElem.setAttribute('data-slide-to', i + 1);
          progElem.setAttribute('tabindex', 0);
          progElem.setAttribute('data-track-masthead', 'slide:' + title);
          var barElem = document.createElement('div');
          barElem.className = 'loading-bar';

          progElem.appendChild(barElem);
          segmentWrapper.appendChild(progElem);
          segmentWrapper.appendChild(titleElem);
          mSegmentWrapper.appendChild(segmentWrapper);
        }
        indicator.appendChild(mSegmentWrapper);

        var pausePlayElem = document.createElement('i');
        pausePlayElem.className = indicatorPause;
        pausePlayElem.setAttribute('data-slide-to', 0);
        pausePlayElem.setAttribute('tabindex', 0);

        indicator.appendChild(pausePlayElem);

        var indicatorWrapper = document.createElement('div');
        var indicatorWrapperClass = ['c-masthead__indicator-wrapper'];

        arrowDownMoreElems.length > 0 &&
          indicatorWrapperClass.push('c-masthead__indicator--bottom-offset');

        indicatorWrapper.className = indicatorWrapperClass.join(' ');

        indicatorWrapper.appendChild(indicator);

        if (sliderContainer.children.length > 1) {
          document.querySelector('.c-masthead').appendChild(indicatorWrapper);
        }

        var indicatorElem = document.querySelectorAll(
          '.c-masthead__indicator__segment-wrapper > div.c-masthead__indicator__slider-bar'
        );
        var pauseResumeElem = document.querySelector(
          '.c-masthead__indicator .c-masthead__indicator__action'
        );
        var segmentElements = document.querySelectorAll('.c-masthead__indicator__segment-wrapper');

        function indicatorsControlPause() {
          pauseResumeElem.classList.remove(faPlay);
          pauseResumeElem.classList.remove(indicatorActive);
          pauseResumeElem.classList.add(faPause);
        }

        function indicatorsControlPlay() {
          pauseResumeElem.classList.remove(faPause);
          pauseResumeElem.classList.add(faPlay);
          pauseResumeElem.classList.add(indicatorActive);
        }

        function indicatorSetActive(index) {
          if (!!indicatorElem) {
            for (var i = 0; i < indicatorElem.length; i++) {
              indicatorElem[i].classList.remove(indicatorActive);
            }
            indicatorElem[index].classList.add(indicatorActive);
          }
        }

        function indicatorsSlideTo() {
          var slideTo = parseInt(this.firstChild.dataset.slideTo);
          if (currentIndex() === slideTo - 1) return;
          change(slideTo - 1);
          pause();
          indicatorSetActive(slideTo - 1);
          indicatorsControlPlay();
          isUserAction = true;
        }

        function indicatorsPauseResume() {
          isUserAction = pauseResumeElem.classList.contains(faPause);
          if (pauseResumeElem.classList.contains(faPause)) {
            pause();
            indicatorsControlPlay();
          } else {
            resume();
            indicatorsControlPause();
          }
        }

        if (!!segmentElements) {
          if (segmentElements.length === 0) return;
          for (var i = 0; i < segmentElements.length; i++) {
            segmentElements[i].addEventListener('click', indicatorsSlideTo, false);
            segmentElements[i].addEventListener('keypress', indicatorsSlideTo, false);
          }

          pauseResumeElem.addEventListener('click', indicatorsPauseResume, false);
          indicatorElem[0].classList.add(indicatorActive);
        }

        if (!!indicator) {
          indicator.addEventListener('mouseover', function (event) {
            if (isUserAction) return;
            pause();
            indicatorsControlPlay();
          });
          indicator.addEventListener('mouseout', function (event) {
            if (isUserAction) return;
            resume();
            indicatorsControlPause();
          });
        }

        return {
          id: options.id,
          currentIndex: currentIndex,
          pause: pause,
          resume: resume,
          nextIndex: nextIndex,
          prevIndex: prevIndex,
          next: next,
          prev: prev,
          change: change,
          reverse: reverse,
          dispose: dispose,
        };
      }

      return MastheadSlider;
    })();

    if (typeof document !== 'undefined') {
      var mastheadComponentId = '';

      var sliderContainer = document.querySelector('.c-masthead__slider');
      var mastHead = document.querySelector('.c-masthead');

      if (mastHead && mastHead.className.indexOf('exp-editor') !== -1) return;
      if (sliderContainer === null) return;
      var slider = new MastheadSlider({
        id: mastheadComponentId,
        container: sliderContainer,
        init: 100,
        show: 0,
        end: -100,
        unit: '%',
        delay: sliderContainer.getAttribute('slider-delay'),
      });

      var videoCTA = new VideoButton({
        sliderClass: 'c-masthead__slider__item',
        videoButtonClass: 'c-button--video',
        attributeLabelNamelPlay: 'sr-label-play',
        attributeLabelNamelPause: 'sr-label-pause',
        attributeIconNamelPlay: 'sr-icon-play',
        attributeIconNamelPause: 'sr-icon-pause',
        ctaButtonClass: 'c-button--cta',
        mastheadSliderObject: slider,
      });

      videoCTA.renderSliderVideoButton();

      // TODO: remove when we stop supporting IE11
      // IE doesn't support object-fit css property and picture element, so let's replace picture with background-image
      // image is adjusted to the viewport size
      var isIE =
        navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0;
      if (isIE) {
        var items = mastHead.querySelectorAll('.c-masthead__slider__item');
        var isMobile = function () {
          return window.matchMedia('(max-width: 740px)').matches;
        };
        var isTablet = function () {
          return window.matchMedia('(max-width: 1024px)').matches;
        };
        var setCorrectBackground = function (sliderItem) {
          var smallSrc = sliderItem.getAttribute('data-background-image-small');
          var mediumSrc = sliderItem.getAttribute('data-background-image-medium');
          var largeSrc = sliderItem.getAttribute('data-background-image-large');
          if (isMobile() && smallSrc) {
            sliderItem.style.backgroundImage = 'url(' + smallSrc + ')';
          } else if (isTablet() && mediumSrc) {
            sliderItem.style.backgroundImage = 'url(' + mediumSrc + ')';
          } else {
            sliderItem.style.backgroundImage = 'url(' + largeSrc + ')';
          }
        };

        for (var i = 0; i < items.length; i++) {
          var content = items[i].querySelector('.c-masthead__slider__item__content');
          var img = items[i].querySelector('.c-masthead__slider__item__content > picture');
          if (content && img) {
            setCorrectBackground(content);
            img.remove();
          }
        }

        // to call resize event handler only once for every resize
        var debounce = function (task, timeout) {
          var timeoutId = 0;
          return function () {
            if (timeoutId) return;
            timeoutId = setTimeout(function () {
              task();
              timeoutId = 0;
            }, timeout);
          };
        };

        window.addEventListener(
          'resize',
          debounce(function () {
            for (var i = 0; i < items.length; i++) {
              var content = items[i].querySelector('.c-masthead__slider__item__content');
              setCorrectBackground(content);
            }
          }, 500)
        );
      }
    }
  }, []);
};

export default useMasthead;
